import React from 'react';
import { useNavigate } from 'react-router-dom';
import OrganizationForm from '../components/OrganizationForm';

/**
 * Organization onboarding page that handles the organization creation
 * flow and redirects to the dashboard afterward
 */
const OrganizationOnboarding = () => {
    const navigate = useNavigate();

    const handleOrganizationSuccess = (organization) => {
        // After successful organization creation, redirect to the dashboard
        // with London Book Fair specific parameter
        navigate(`/dashboard?organizationId=${organization.id}&lbf=true`);
    };

    return (
        <OrganizationForm onSuccess={handleOrganizationSuccess} />
    );
};

export default OrganizationOnboarding; 